//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { ICuralateStore } from '@models/AppState';
import { createSelector } from 'reselect';

export const getScheduleMediaMap = createSelector(
  (state: ICuralateStore) => state.scheduleMedia,
  (scheduleMediaStore) => scheduleMediaStore.mediaItems,
);
